<div class="dialog-content home-router-dialog">
  <!--btn:關閉按鈕-->
  @if (data.showCloseButton) {
    <button mat-button (click)="close()" class="dialog-close-btn">
      <img src="assets/img/i-close.svg" alt="" />
    </button>
  }

  <!--title 標題-->
  <h1 class="dialog-title">{{ 'home-router-dialog.title' | translate }}</h1>

  <!--dialog 內容-->
  <div mat-dialog-content class="dialog-body">
    <p class="dialog-description">
      {{ 'home-router-dialog.message' | translate }}<br>
    </p>

    <!-- 重點提示區塊 -->
    <div class="highlight-box">
      <div class="highlight-header">
        <img src="assets/img/Shield_Check.png" alt="" class="check-icon" />
        <span>{{ 'home-router-dialog.highlight-item-1' | translate }}</span>
      </div>
      <div class="highlight-header">
        <img src="assets/img/calendar.png" alt="" class="check-icon" />
        <span>{{ 'home-router-dialog.highlight-item-2' | translate }}</span>
      </div>
    </div>


  <button mat-button class="btn-fill-primary btn-size-l" (click)="data.action()">
    {{ 'home-router-dialog.button-text' | translate }}
  </button>

  <div class="btn-wrapper">
    <button mat-button class="btn-text-underline btn-size-s" (click)="goToOldWeb()">
      {{ 'home-router-dialog.button-text-2' | translate }}
    </button>
  </div>
</div>
